import React from "react";
import Modal from "./";

function noop() {}

const defaultProps = {
  positiveButton: "YES",
  negativeButton: "CANCEL",
  onPositiveClick: noop,
  onNegativeClick: noop,
  footer: true,
};

function ModalContent({
  children,
  isOpen,
  onClosed,
  size,
  positiveButton,
  negativeButton,
  onPositiveClick,
  onNegativeClick,
  footer,
  showCloseButton,
  className,
}) {
  const [open, setOpen] = React.useState(isOpen);
  React.useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);
  const style = {
    minWidth: "6em",
  };
  return (
    <Modal isOpen={open} onClosed={onClosed} size={size}>
      <div
        style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          zIndex: 100,
          cursor: "pointer",
        }}
        onClick={() => setOpen(false)}
      >
        <i class="bi bi-x fs-4"></i>
      </div>
      <Modal.Body className="pb-0 ps-4 pe-4 pt-4">{children}</Modal.Body>
      {footer && (
        <div className="row justify-content-center gap-2 modal-footer border-0 p-4">
          {negativeButton ? (
            <button
              style={{ ...style }}
              onClick={() => {
                setOpen(false);
                onNegativeClick();
              }}
              type="button"
              className="btn btn-light fs-sm ms-2 col-auto fw-semibold"
            >
              {negativeButton}
            </button>
          ) : null}
          <button
            style={{
              ...style,
            }}
            onClick={() => {
              setOpen(false);
              onPositiveClick();
            }}
            type="submit"
            className="btn btn-primary fs-sm col-auto fw-semibold"
          >
            {positiveButton}
          </button>
        </div>
      )}
    </Modal>
  );
}

ModalContent.defaultProps = defaultProps;
export default ModalContent;
